import React from "react";
import { Link } from "react-router-dom";
import { useI18n } from "../lib/i18n";
import { Envelope, MapPin, Compass } from "@phosphor-icons/react";
import { OpenGuideLink } from "./OnboardingGuide";

export default function Footer() {
  const { t } = useI18n();
  return (
    <footer className="border-t border-border bg-accent/30 mt-32" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2 max-w-md">
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-mc68.png" alt="Mon Commerce 68" className="w-10 h-10 rounded-sm object-contain" />
            <span className="font-display font-semibold">Mon Commerce 68</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">{t.footer.tagline}</p>
          <div className="mt-6 space-y-2 text-sm text-muted-foreground">
            <div className="flex items-start gap-2">
              <MapPin size={16} className="mt-0.5 shrink-0" />
              <span>STEGO DAMIEN — Digital Corp France<br/>9 rue André Koechlin-Dollfus, 68200 Mulhouse</span>
            </div>
            <div className="flex items-center gap-2">
              <Envelope size={16} />
              <a href="mailto:moncommerce68@gmail.com" className="hover:text-foreground" data-testid="footer-support-email">moncommerce68@gmail.com</a>
            </div>
          </div>
        </div>
        <div>
          <div className="label-uppercase mb-4">Navigation</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/annuaire" className="text-muted-foreground hover:text-foreground">{t.nav.directory}</Link></li>
            <li><Link to="/passez-partenaire" className="text-muted-foreground hover:text-foreground">{t.nav.partner}</Link></li>
            <li><Link to="/connexion" className="text-muted-foreground hover:text-foreground">{t.nav.login}</Link></li>
            <li><Link to="/a-propos" className="text-muted-foreground hover:text-foreground">{t.footer.about}</Link></li>
            <li>
              <OpenGuideLink track="client" className="inline-flex items-center gap-1.5 text-muted-foreground hover:text-foreground">
                <Compass size={14} weight="bold" /> Guide d&apos;utilisation
              </OpenGuideLink>
            </li>
            <li>
              <Link to="/teleprospecteur" className="text-muted-foreground hover:text-foreground text-xs" data-testid="footer-telepro-link">
                Espace téléprospecteurs
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="label-uppercase mb-4">Légal</div>
          <ul className="space-y-2 text-sm">
            <li><Link to="/mentions-legales" className="text-muted-foreground hover:text-foreground">{t.footer.legal}</Link></li>
            <li><Link to="/cgu" className="text-muted-foreground hover:text-foreground">{t.footer.cgu}</Link></li>
            <li><Link to="/cgv" className="text-muted-foreground hover:text-foreground">{t.footer.cgv}</Link></li>
            <li><Link to="/rgpd" className="text-muted-foreground hover:text-foreground">{t.footer.rgpd}</Link></li>
            <li><Link to="/cookies" className="text-muted-foreground hover:text-foreground">{t.footer.cookies}</Link></li>
            <li>
              <button
                type="button"
                onClick={() => {
                  try { localStorage.removeItem("mc68_cookies"); } catch { /* noop */ }
                  window.dispatchEvent(new Event("mc68:cookies:reopen"));
                }}
                className="text-muted-foreground hover:text-foreground text-left"
                data-testid="footer-cookies-reopen"
              >
                Modifier mes cookies
              </button>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border">
        <div className="mx-auto max-w-7xl px-6 lg:px-10 py-6 text-xs text-muted-foreground flex flex-col md:flex-row justify-between gap-3">
          <div>© {new Date().getFullYear()} STEGO DAMIEN — Mon Commerce 68</div>
          <div>Made in Mulhouse · Haut-Rhin · France</div>
        </div>
      </div>
    </footer>
  );
}
